<template>
  <span class="combobox-rental-counter-mutation-display">
    <span class="italic">
      <span v-if="isBeingUpdated">Aan het afboeken...</span>
      <span v-else-if="modelValue.getRemainingQuantity() > 0">
        {{ normalizeDecimal(modelValue.getRemainingQuantity(), { minDecimalPlaces: 0 }) }}/{{
          normalizeDecimal(modelValue.quantity, { minDecimalPlaces: 0 })
        }}
        af te boeken
      </span>
      <span v-else>
        ({{ normalizeDecimal(modelValue.getCounterQuantity(), { minDecimalPlaces: 0 }) }}/{{
          normalizeDecimal(modelValue.quantity, { minDecimalPlaces: 0 })
        }}
        afgeboekt)
      </span>
    </span>
  </span>
</template>

<script setup lang="ts">
import type { RentalIntake } from "@/models/rental-intake.model"
import type { RentalDispense } from "@/models/rental-dispense.model"
import { normalizeDecimal } from "@/helper/number-helper"

defineProps({
  modelValue: {
    type: Object as () => RentalIntake | RentalDispense,
    required: true
  },
  isBeingUpdated: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped></style>
